import React from "react";
import { MessageCircle, Instagram, Mail, MapPin } from "lucide-react";
import { SiteLayout, useSettings, waLink } from "@/components/SiteLayout";
import { useI18n } from "@/lib/i18n";

export default function Contact() {
  const s = useSettings();
  const { t } = useI18n();
  return (
    <SiteLayout>
      <div className="mx-auto max-w-3xl px-5 py-16">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">{t("contact")}</h1>
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {[[MessageCircle, "WhatsApp", s?.whatsapp_number], [Instagram, "Instagram", s?.instagram],
            [Mail, "Email", s?.email], [MapPin, "Self Pickup Address", s?.pickup_address || s?.address]].map(([Icon, label, val], i) => (
            <div key={label} className="lm-card rounded-xl p-5" data-testid={`contact-${label.toLowerCase()}`}>
              <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-ink-soft"><Icon size={14} /> {label}</div>
              <div className="mt-2 text-base">{val || "-"}</div>
            </div>
          ))}
        </div>
        <a href={waLink(s?.whatsapp_number, "Hello LapakMahjong.id!")} target="_blank" rel="noreferrer"
          data-testid="contact-wa-btn" className="mt-8 inline-block lm-btn-primary rounded-full px-8 py-4 text-sm font-semibold">
          {t("whatsappUs")}
        </a>
      </div>
    </SiteLayout>
  );
}
